import routes from '@/modules/expense/routes'
import store from '@/modules/expense/store'

export default { routes, store }
